var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative intro"},[_c('div',{staticClass:"image_block "},[_c('visual',{attrs:{"image":_vm.bgImage,"background":"cover","aspect":16/9,"load":"visible"}}),_c('storer',{attrs:{"storer":_vm.storer}})],1),_c('opening')],1)}
var staticRenderFns = []

export { render, staticRenderFns }